import { Monitor, Server, Code, Users, Zap, Shield, CheckCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: <Monitor className="h-12 w-12" />,
      title: 'Digital Transformation',
      description: 'Transform your business with cutting-edge digital solutions that drive growth and efficiency.',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=1920',
      features: [
        'Business Process Automation',
        'Cloud Migration',
        'Digital Workplace Solutions',
        'Data Analytics & Insights'
      ]
    },
    {
      icon: <Server className="h-12 w-12" />,
      title: 'IT Support',
      description: 'Comprehensive 24/7 technical support to ensure your systems run smoothly and efficiently.',
      image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80&w=1920',
      features: [
        'Help Desk Support',
        'Network Management',
        'System Maintenance',
        'Hardware Support'
      ]
    },
    {
      icon: <Code className="h-12 w-12" />,
      title: 'Application Development',
      description: 'Custom software solutions tailored to your specific business needs and objectives.',
      image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&q=80&w=1920',
      features: [
        'Web Applications',
        'Mobile Apps',
        'Enterprise Software',
        'API Integration'
      ]
    },
    {
      icon: <Users className="h-12 w-12" />,
      title: 'IT Consulting',
      description: 'Expert guidance for your technology decisions and digital strategy.',
      image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&q=80&w=1920',
      features: [
        'Technology Assessment',
        'Strategic Planning',
        'Project Management',
        'IT Roadmap Development'
      ]
    },
    {
      icon: <Zap className="h-12 w-12" />,
      title: 'IT Service Management',
      description: 'Streamline your IT operations and enhance efficiency with our ITSM solutions.',
      image: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&q=80&w=1920',
      features: [
        'Service Desk',
        'Asset Management',
        'Change Management',
        'Process Optimization'
      ]
    },
    {
      icon: <Shield className="h-12 w-12" />,
      title: 'Cybersecurity',
      description: 'Protect your business with advanced security solutions and best practices.',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&q=80&w=1920',
      features: [
        'Security Assessments',
        'Threat Protection',
        'Compliance Management',
        'Security Training'
      ]
    }
  ];

  return (
    <div className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Our Services</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive IT solutions tailored to meet your business needs and drive digital success
          </p>
        </div>

        <div className="grid gap-12">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="relative h-64 md:h-96">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-transparent flex items-center">
                  <div className="p-8 md:p-12 max-w-2xl">
                    <div className="text-blue-400 mb-4">{service.icon}</div>
                    <h2 className="text-3xl font-bold text-white mb-4">{service.title}</h2>
                    <p className="text-white/90 text-lg mb-6">{service.description}</p>
                    <Link
                      to="/contact"
                      className="inline-flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                    >
                      Get Started
                      <ArrowRight className="ml-2 h-5 w-5" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="p-8 bg-gray-50">
                <h3 className="text-xl font-semibold mb-4">Key Features</h3>
                <div className="grid md:grid-cols-2 gap-4">
                  {service.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center">
                      <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}